import { Grid, Card, CircularProgress, makeStyles, Typography } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import TableGeneric from '../../../compartidos/abms/TableGeneric';
import { fetchTraerContratosRed, generateExcelContratosRed, generatePDFContratosRed } from '../../../../actions/contrataciones/contratacionesReportes';
import ToolbarXLSPDF from '../../../compartidos/ToolbarXLSPDF';
import { useReactToPrint } from 'react-to-print';
import CantRedes from './CantRedes';
import { fetchLocalidades } from '../../../../actions/cbos/localidades';
import { fetchProvincias } from '../../../../actions/cbos/provincias';
import { getCartilla, getCentrosMedicos, getPlanes, getRankingsCartilla, getRubrosEfector, getZonasEfector } from '../../../../actions/contrataciones/contratacionesCartilla';
import { fetchEspecialidades } from '../../../../actions/especialidades';


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(2)
    },
    rootDatos: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper,
        padding: 10,
        marginTop: 20
    },
    button: {
        marginTop: theme.spacing(2),
        float: "right"
    },
    input: {
        display: 'none',
    },
}));

const RedScreen = () => {
    const classes = useStyles();
    const dispatch = useDispatch()
    const { contratosRed, loading } = useSelector(state => state.contratacionesReportes)

    const componentRef = React.useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    useEffect(() => {
        dispatch(fetchTraerContratosRed())
        
        dispatch(fetchLocalidades())
        dispatch(fetchProvincias())
        dispatch(getCentrosMedicos())
        dispatch(fetchEspecialidades(true))
        dispatch(getRubrosEfector())
        dispatch(getZonasEfector())
        dispatch(getRankingsCartilla())
        dispatch(getCartilla())
        dispatch(getPlanes())

        // eslint-disable-next-line
    }, []);

    return (
        <div className={classes.root}>
            <Grid container spacing={1} direction="row" justify="center" alignItems="center">
                <Grid item xs={12} md={10}>
                    <Card>
                        <Grid container spacing={1} direction="row" justify="center" alignItems="center">
                            <Grid item xs={8}>
                                <Typography variant="subtitle1" style={{ padding: 16 }}>
                                    Listado de Contratos
                                    {
                                        loading &&
                                        <CircularProgress size={24} style={{ marginLeft: 15 }} />
                                    }
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <ToolbarXLSPDF
                                    handlePrint={handlePrint}
                                    handleExportExcel={() => dispatch(generateExcelContratosRed())}
                                    handleGeneratePdf={() => dispatch(generatePDFContratosRed())}
                                />
                            </Grid>
                        </Grid>

                        <TableGeneric
                            ref={componentRef}
                            data={contratosRed}
                            columns={[
                                {
                                    label: "Código contrato",
                                    id: "idEfectorFacturacion",
                                    sort: true
                                },
                                {
                                    label: "Razón social",
                                    id: "razonSocial",
                                    sort: true,
                                },
                                {
                                    label: "Nombre de fantasía",
                                    id: "nombreFantasia",
                                    sort: true,
                                },
                                {
                                    label: "Cuit",
                                    id: "cuit",
                                    sort: true,
                                },
                                {
                                    label: "Cantidad REDES",
                                    id: "cantRedes",
                                    sort: true,
                                    customBody: (item) => <CantRedes item={item} />
                                }
                            ]}
                        />
                    </Card>
                </Grid>
            </Grid>
        </div>
    )
}

export default RedScreen
